import api from './api';

export interface PredictionComparison {
  id: number;
  predictionId: number;
  actualDataSourceId: number;
  name: string;
  description?: string;
  yearMonth: string;
  creditTypeIds: string;
  creditTypeNames: string;
  actualInitialDebt: number;
  actualPurchasePrice: number;
  actualCaseCount: number;
  normalizationFactor: number;
  createdAt: string;
  updatedAt: string;
  prediction: {
    id: number;
    fileName: string;
    mappingName: string;
    modelType: string;
    createdAt: string;
    status: string;
  };
}

export interface CreateComparisonRequest {
  predictionId: number;
  actualDataSourceId: number;
  name: string;
  description?: string;
  yearMonth: string;
  creditTypeIds: number[];
  creditTypeNames: string;
}

const predictionComparisonService = {
  async createComparison(data: CreateComparisonRequest): Promise<PredictionComparison> {
    const response = await api.post('/prediction-comparisons', data);
    return response.data;
  },

  async getComparisons(): Promise<PredictionComparison[]> {
    const response = await api.get('/prediction-comparisons');
    return response.data;
  },

  async getComparisonsCount(): Promise<number> {
    const response = await api.get('/prediction-comparisons/stats/count');
    return response.data.count;
  },

  async getComparison(id: number): Promise<PredictionComparison> {
    const response = await api.get(`/prediction-comparisons/${id}`);
    return response.data;
  },

  async deleteComparison(id: number): Promise<void> {
    await api.delete(`/prediction-comparisons/${id}`);
  },
};

export default predictionComparisonService;
